import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerCreateContract.css';
import { ExtendedButton,MessageBox,EmailField } from 'component-lib';
import {RequestAjaxClass, EmailModel } from 'models-lib';

class ChangeEmail extends Component
{

  constructor(props)
  {
    super(props);
    this.state = {};
    this.Email = props.match.params.Email;
    this.CustomerId = props.match.params.CustomerId;
    this.PostRequest = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
    this.EmailModel = new EmailModel([this]);
  }

  componentDidMount(){
    this.PostRequest.setApiKey(Vas.ApiKey);
    this.PostRequest.setApiUrl(Vas.ApiUrl);
    this.PostRequest.setAuth(true);
    this.EmailModel.SetRequest(this.PostRequest);
  }

  Close()
  {
    ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
    $("#Content").css("opacity", "1");
  }

  Update(){
    this.setState({},()=>{
      if(this.EmailModel.ChangeSuccess === true){
        Vas.GetView("ChangeMailSuccess",{CustomerId:this.CustomerId},true);
      }else{
        ReactDOM.render(<MessageBox 
          AppURL={Vas.AppURL} 
          Title={Vas.Resources.Titles["Note"]} 
          Message={Vas.Resources.Labels["EmailNotChanged"]} 
        />,document.getElementById('messageContainer'));
      }
    });
  }

  changeEmail(){
    if (this.state.Email){
      if (this.state.Email.length > 0 && this.refs.email2.getValid() === true){
        this.EmailModel.ChangeMail(this.state.Email);
      } else {
        if (this.refs.email2.getExist() === true){
          ReactDOM.render(<MessageBox 
            AppURL={Vas.AppURL} 
            Title={Vas.Resources.Titles["Note"]} 
            Message={Vas.Resources.Labels["EmailExist"]} 
          />,document.getElementById('messageContainer'));
        } else {
          ReactDOM.render(<MessageBox 
            AppURL={Vas.AppURL} 
            Title={Vas.Resources.Titles["Note"]} 
            Message={Vas.Resources.Labels["InvalidEMail"]} 
        />,document.getElementById('messageContainer'));
        }
        
      }
    } else {
      ReactDOM.render(<MessageBox 
        AppURL={Vas.AppURL} 
        Title={Vas.Resources.Titles["Note"]} 
        Message={Vas.Resources.Labels["InvalidEMail"]} 
      />,document.getElementById('messageContainer'));
    }
  }

  Cancel(){
    Vas.GetView("CustomerCardData",{Id:localStorage.getItem("Number_CurrentCustomer")},true);
  }

  render()
  {
    return (
      <div className={"form"}>
        <table >
          <thead>
            <tr>
              <th className={"headerChange"} colSpan={2}>
                {Vas.Resources.Labels["ChangeEmail"]}
                <br />
                <br />
              </th>
            </tr>
          </thead>
        <tbody>
          <tr>
            <td colSpan={2}>
              <EmailField 
                ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                ApiUrl={Vas.ApiUrl} 
                ApiKey={Vas.ApiKey}
                AppURL={Vas.ApplicationUrl} 
                AnonymousToken={localStorage.getItem["anonymous_token"]} 
                Editable={true}
                Float={'left'} 
                Id="email2" 
                IsRequired={true}
                Label={Vas.Resources.Labels["NewEmail"]} 
                me={this} 
                OnChange={()=>{this.setState({ Email:$('#email2').val() });}}
                ref={"email2"} 
                Tooltip={Vas.Resources.Tooltips["Email"]} 
                Token={localStorage.getItem["vas_token"]} 
                Width={360}
              />
              <br />
            </td>
          </tr>
          <tr>
            <td >
              <ExtendedButton
                Float={'left'} 
                OnClick={()=>{this.changeEmail();}}
                Text={Vas.Resources.Labels["ChangeEmail"]}
                Usable={true} 
                Width={180}
              />
            </td>
            <td>
            <ExtendedButton
                Float={'left'} 
                OnClick={()=>{this.Cancel();}}
                Text={Vas.Resources.Labels["Cancel"]}
                Usable={true} 
                Width={180}
              />
            </td>
          </tr>
        </tbody>
      </table>
      </div>
      
    );
  }
}
export default ChangeEmail;
